import React from 'react';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';
import { styled } from 'styled-components';
import { CaseTag } from '@debbie/common/dist/cases/index.js';
import { CaseVoucherSource } from '@debbie/common/dist/economy/case-vouchers/index.js';
import { VoucherCategory, } from '@debbie/common/dist/economy/vouchers/index.js';
import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import { selectVoucherTypes } from '@debbie/cortex/dist/economy/selectors.js';
import { Button, ButtonGroup, Input, Select } from '../../index.js';
import THEME from '../../../theme.js';
import X from '../../Icons/X.js';
const ShareEditor = (props) => {
    const lang = useSelector((s) => s.lang);
    const voucherTypes = useSelector(selectVoucherTypes);
    const { share, onChange, onDelete } = props;
    return (React.createElement(ShareStyled, null,
        !props.readOnly && (React.createElement(X, { style: {
                cursor: 'pointer',
                position: 'absolute',
                top: '20px',
                right: '20px',
            }, onClick: () => onDelete() })),
        React.createElement("h4", null, lang.billingModels.categoriesOrTypesFilter),
        React.createElement(ReactSelect, { value: []
                .concat((share.voucherTypeIds || []).map((voucherTypeId) => {
                const voucherType = voucherTypes?.find((v) => v.voucherTypeId === voucherTypeId);
                return {
                    label: (voucherTypeId &&
                        lang.pluralEconomyVoucherTypeLabels[voucherTypeId]) ||
                        voucherType?.label ||
                        voucherTypeId,
                    value: voucherTypeId,
                };
            }))
                .concat((share.categories || []).map((category) => {
                return {
                    label: (category &&
                        lang.economyCategories[category]) ||
                        category,
                    value: category,
                };
            })), isMulti: true, placeholder: lang.billingModels.selectVouchersGroup, classNamePrefix: "select", options: []
                .concat(!share.voucherTypeIds
                ? CaseVoucherCategories.filter((category) => ![VoucherCategory.TRANSACTION].includes(category)).map((category) => ({
                    label: `${lang.billingModels.voucherCategory} - ${lang.economyCategories[category]}`,
                    value: category,
                }))
                : [])
                .concat(!share.categories
                ? (voucherTypes || [])
                    .filter((voucherType) => [
                    VoucherCategory.COST,
                    VoucherCategory.COURTCOST,
                    VoucherCategory.INTEREST,
                    VoucherCategory.PRINCIPAL,
                ].includes(voucherType.category))
                    .map((voucherType) => ({
                    label: `${lang.billingModels.voucherType} - ${lang.pluralEconomyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label}`,
                    value: voucherType.voucherTypeId,
                }))
                : []), onChange: (val) => {
                const isCategories = val &&
                    val[0] &&
                    !!CaseVoucherCategories.find((category) => val[0].value === category);
                onChange({
                    voucherTypeIds: typeof isCategories === 'boolean' && !isCategories
                        ? (val || []).map((v) => v.value)
                        : undefined,
                    categories: isCategories
                        ? (val || []).map((v) => v.value)
                        : undefined,
                });
            }, isDisabled: props.readOnly }),
        React.createElement("br", null),
        React.createElement("h4", null, lang.billingModels.caseTagFilter),
        React.createElement(Select, { onChange: (e) => {
                onChange({
                    caseTag: e.target.value || undefined,
                });
            }, value: share.caseTag, disabled: props.readOnly },
            React.createElement("option", { value: "" }, lang.billingModels.allVouchers),
            React.createElement("option", { value: CaseTag.SURVEILLANCE }, lang.billingModels.caseTagSurveillanceFilter)),
        React.createElement("h4", null, lang.billingModels.voucherTagFilter),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { onClick: () => {
                    onChange({
                        caseVoucherSource: undefined,
                    });
                }, theme: !share.caseVoucherSource ? undefined : 'secondary', size: "mini", disabled: props.readOnly }, lang.billingModels.allVouchers),
            React.createElement(Button, { onClick: () => {
                    onChange({
                        caseVoucherSource: CaseVoucherSource.Creditor,
                    });
                }, theme: share.caseVoucherSource === CaseVoucherSource.Creditor
                    ? undefined
                    : 'secondary', size: "mini", disabled: props.readOnly }, lang.billingModels.imposedByCreditor),
            React.createElement(Button, { onClick: () => {
                    onChange({
                        caseVoucherSource: CaseVoucherSource.Collector,
                    });
                }, theme: share.caseVoucherSource === CaseVoucherSource.Collector
                    ? undefined
                    : 'secondary', size: "mini", disabled: props.readOnly }, lang.billingModels.imposedByCollector)),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("h4", null, lang.billingModels.feeFraction),
        React.createElement(Input, { placeholder: lang.billingModels.feeFractionPlaceholder, type: "number", value: share.feeFraction ? Math.round(share.feeFraction * 10000) / 100 : '', onChange: (e) => {
                const percentage = e.target.value
                    ? parseFloat(e.target.value)
                    : undefined;
                console.log(percentage);
                onChange({
                    feeFraction: percentage ? percentage / 100 : undefined,
                });
            }, disabled: props.readOnly })));
};
export const ShareStyled = styled.div `
  position: relative;
  background: #ffffff5a;
  margin-bottom: ${THEME.GRID_SPACING}px;
  border-radius: 3px;
  padding: ${THEME.GRID_SPACING}px;

  h4 {
    margin-top: 0;
  }
`;
export default ShareEditor;
//# sourceMappingURL=ShareEditor.js.map